import { getState } from "../state/store";
import { selectConsentElements, selectConsents, selectSelectedConsent } from "../state/selectors";

import { consentStatuses } from "../consts";

const getConsents = (consents) => {
  return consents?.filter((consent) => consent?.status !== consentStatuses.draft);
};

const getDrafts = (consents) => {
  return consents?.filter((consent) => consent?.status === consentStatuses.draft);
};

const setConsentElementsIds = (consentElements) => {
  return consentElements?.map((consentElement, index) => {
    return { ...consentElement, id: index + 1 };
  });
};

const removeConsentElementsIds = (consentElements) => {
  return consentElements?.map((item) => {
    const formattedItem = { ...item };
    delete formattedItem.id;

    return formattedItem;
  });
};

const getNewConsentElementId = (consentElements) => {
  return consentElements?.length + 1;
};

const formatConsentElements = (consentElements) => {
  return consentElements.map((item) => {
    const formattedItem = { ...item };

    delete formattedItem.createdAtTs;
    delete formattedItem.updatedAtTs;

    formattedItem.texts = formatConsentTexts(formattedItem.texts);

    return formattedItem;
  });
};

const formatConsentTexts = (texts) => {
  const formattedTexts =
    texts &&
    texts.map((data) => {
      return {
        ...data,
        content: data?.content
          ?.replaceAll("<p>", "")
          ?.replaceAll("</p>", "")
          ?.replaceAll(/&nbsp;/g, "")
          ?.replaceAll(/\n/g, "")
      };
    });

  return formattedTexts;
};

const checkIsSameConsentElements = (originalItems, consentElements) => {
  let isSame = true;

  if (originalItems?.length !== consentElements?.length) {
    isSame = false;
  } else {
    const originalItemsFormatted = formatConsentElements(originalItems);
    const consentElementsFormatted = formatConsentElements(consentElements);

    isSame = JSON.stringify(originalItemsFormatted) === JSON.stringify(consentElementsFormatted);
  }

  return isSame;
};

const getNewConsentVersion = () => {
  const consents = selectConsents()(getState());

  const consentsWithVersion = consents.filter(
    (consent) => consent.version !== null && !isNaN(Number(consent.version))
  );

  const version = consentsWithVersion.length
    ? Math.max(...consentsWithVersion.map((consent) => consent.version)) + 1
    : 0;

  return version;
};

const hasNewTexts = (consentElement) => {
  const selectedConsent = selectSelectedConsent()(getState());

  const originalConsentElement = selectedConsent?.items?.find(
    (item) => item?.id === consentElement?.id
  );

  return (
    originalConsentElement?.texts?.length !== consentElement?.texts?.length ||
    originalConsentElement?.texts?.filter((t) => t?.content?.length)?.length !==
      consentElement?.texts?.filter((t) => t?.content?.length)?.length
  );
};

const getConsentElementUpdatedTexts = (consentElements) => {
  return consentElements
    ?.filter((item) => {
      return hasNewTexts(item);
    })
    ?.map((item) => {
      const formattedItem = {};

      formattedItem.consentsItemPosition = item.position;
      formattedItem.texts = item?.texts;

      return formattedItem;
    });
};

const getDefaultConsentElementLangs = () => {
  const consentElements = selectConsentElements()(getState());

  if (consentElements?.length) {
    return consentElements[0]?.texts;
  }

  return null;
};

const alignConsentElementTexts = (baseConsentElement, consentElements) => {
  const baseConsentElementLangs = baseConsentElement?.texts?.map((t) => t.languageCode);

  const baseIdx = consentElements?.findIndex(
    (consentElement) => consentElement.id === baseConsentElement?.id
  );

  const newConsentElements = consentElements?.map((consentElement, index) => {
    let newTexts =
      consentElement?.texts?.filter((t) => baseConsentElementLangs.includes(t.languageCode)) ?? [];

    if (index !== baseIdx) {
      baseConsentElementLangs.map((lang) => {
        const consentElementLangs = consentElement?.texts?.map((t) => t.languageCode) ?? [];

        if (!consentElementLangs.includes(lang)) {
          newTexts.push({
            languageCode: lang,
            content: ""
          });
        }
      });
    }

    return {
      ...consentElement,
      texts: newTexts
    };
  });

  return newConsentElements;
};

const consentUtil = {
  getConsents,
  getDrafts,
  setConsentElementsIds,
  removeConsentElementsIds,
  getNewConsentElementId,
  formatConsentTexts,
  checkIsSameConsentElements,
  getNewConsentVersion,
  getConsentElementUpdatedTexts,
  getDefaultConsentElementLangs,
  alignConsentElementTexts
};

export default consentUtil;
